module.exports = __webpack_public_path__ + "static/media/img_qrcode.4559ec32.svg";